/**
 * App.js - Root: ThemeProvider (theme color + Poppins like admin4.0) + CacheProvider + PermissionsProvider + Muidrawer.
 */
import "./App.css";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import Muidrawer from "./Shell/Muidrawer";
import { CacheProvider } from "./Utility/CacheContext";
import { PermissionsProvider } from "./Utility/PermissionContext";
import { Colors } from "./Styles/Colors";

const theme = createTheme({
  typography: {
    fontFamily: '"Poppins", sans-serif',
  },
  palette: {
    background: {
      default: Colors.BgColor,
    },
    primary: {
      main: Colors.ThemeColor,
      contrastText: Colors.ContrastText,
    },
    secondary: {
      main: Colors.SecondaryColor,
      contrastText: Colors.ContrastText,
    },
    others: {
      main: "#c400ff",
      light: "#d966ff",
      dark: "#ad00e0",
      contrastText: Colors.ContrastText,
    },
  },
  components: {
    MuiTooltip: {
      styleOverrides: {
        tooltip: {
          fontSize: "0.8dvw",
        },
      },
    },
    MuiDrawer: {
      styleOverrides: {
        paper: {
          backgroundColor: Colors.pageTopBackground,
        },
      },
    },
    MuiChip: {
      styleOverrides: {
        label: {
          fontSize: "0.7dvw",
        },
        root: {
          "&.MuiChip-colorOthers": {
            "&:hover": {
              backgroundColor: "#d678f3ff",
            },
          },
        },
      },
    },
  },
});

export default function App() {
  return (
    <ThemeProvider theme={theme}>
      <CacheProvider>
        <PermissionsProvider>
          <Muidrawer />
        </PermissionsProvider>
      </CacheProvider>
    </ThemeProvider>
  );
}
